import {NgModule} from '@angular/core';
// import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { ProfileInformationList } from './ProfileInformationList';
import { LudyUiReactModule } from '../../../../../tsScripts/components/ludyUIReact/LudyUiReactModule';
import { aDisabledModule } from '../../../../../tsScripts/directives/aDisabled';
import { CommonModule } from '@angular/common';


@NgModule({
    declarations: [ProfileInformationList],
    imports: [CommonModule,LudyUiReactModule,FormsModule,aDisabledModule],
    entryComponents:[],
    exports:[ProfileInformationList]

})
export class ProfileModule {

  
}